import { IconButton } from 'copilot-design-system';
import { MessageNotificationProps } from 'stream-chat-react';

// based on the default implementations for
// MessageNotification and ScrollToBottomButton
// https://github.com/GetStream/stream-chat-react/blob/master/src/components/MessageList/MessageNotification.tsx
// https://github.com/GetStream/stream-chat-react/blob/master/src/components/MessageList/ScrollToBottomButton.tsx
export const CustomScrollToBottomButton = ({
  onClick,
  isMessageListScrolledToBottom,
}: Pick<
  MessageNotificationProps,
  'onClick' | 'isMessageListScrolledToBottom'
>) => {
  if (isMessageListScrolledToBottom) return null;

  return (
    <IconButton
      className="absolute self-center bottom-3"
      icon="ArrowDownSolid"
      label="Scroll to bottom"
      onClick={onClick}
      variant="secondary"
      aria-live="polite"
    />
  );
};
